import React, { Component } from "react";
import arrow from "../assets/right-arrow.svg";
import { NavLink } from "react-router-dom";
import defaultPicture from "../assets/user.svg";

export default class teamMember extends Component {
  data = this.props.data;
  render() {
    return (
      <NavLink to={{ pathname: `/team/${this.data.identifier}/member` }}>
        <div className="team-member flex space-btw">
          <div className="left flex ">
            <span
              className="dp-rapper"
              style={{
                backgroundImage: `url("${
                  this.data.profile_picture || defaultPicture
                }")`,
              }}
            ></span>
            <p className="name">
              {this.data.first_name} {this.data.last_name}
            </p>
          </div>
          <div className="right">
            <button>
              <img src={arrow} alt="" srcSet="" />
            </button>
          </div>
        </div>
      </NavLink>
    );
  }
}
